import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

function AddToCartButton({ 
  product, 
  quantity = 1, 
  className = '', 
  disabled = false,
  showQuantitySelector = false 
}) {
  const { addToCart, loading } = useCart();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [selectedQuantity, setSelectedQuantity] = useState(quantity);

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    if (!product.active) {
      toast.error('This product is currently unavailable');
      return;
    }

    if (product.stockQuantity < selectedQuantity) {
      toast.error(`Only ${product.stockQuantity} items available`);
      return;
    }

    await addToCart(product.id, selectedQuantity);
  };

  const isOutOfStock = product.stockQuantity === 0;
  const isLowStock = product.stockQuantity < 5;

  return (
    <div className="add-to-cart-container">
      {showQuantitySelector && (
        <div className="quantity-selector">
          <label>Qty:</label>
          <select
            value={selectedQuantity}
            onChange={(e) => setSelectedQuantity(parseInt(e.target.value))}
            disabled={loading || disabled || isOutOfStock}
          >
            {[...Array(Math.min(product.stockQuantity, 10))].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>
      )}

      <button
        onClick={handleAddToCart}
        disabled={loading || disabled || isOutOfStock || !product.active}
        className={`add-to-cart-btn ${className} ${
          isOutOfStock ? 'out-of-stock' : ''
        } ${isLowStock && !isOutOfStock ? 'low-stock' : ''}`}
      >
        {loading ? (
          <span className="loading-spinner">Adding...</span>
        ) : isOutOfStock ? (
          'Out of Stock'
        ) : (
          'Add to Cart'
        )}
      </button>

      {isLowStock && !isOutOfStock && (
        <span className="stock-warning">
          Only {product.stockQuantity} left!
        </span>
      )}
    </div>
  );
}

export default AddToCartButton;